import { DataAttributeDefinitions } from 'scrivito'

import { pisaContactDocumentRelationDataClass } from './Pisa/pisaContactDocumentRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const ContactDocumentRelation =
  pisaContactDocumentRelationDataClass(attributes)
